import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import { SET_CONTEXT_DATA, SET_CONTEXT_FETCHING_LOADING } from './mutations';
import { getServiceContexts, getServiceContextsBySlug } from './getters';
import api from '@/api';
import { getServiceDataBySlug } from '../apps/actions';
import { getServiceBySlug } from '../apps/getters';

const buildContextActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const setContexts = buildContextActionObject('setContexts');
export const setContext = buildContextActionObject('setContext');
export const getContextsOfService = buildContextActionObject('getContextsOfService');
const _fetchContextsOfService = buildContextActionObject('_fetchContextsOfService');
export const setContextFetchingLoading = buildContextActionObject('setContextFetchingLoading');
export const getContextsOfServiceBySlug = buildContextActionObject('getContextsOfServiceBySlug');

const promises = {}; // { [serviceId/slug]: Promise }

const actions = {
	...StoreModuleService.createDefaultActions(),
	async [setContexts.action]({ dispatch }, payload) {
		const { data } = payload;
		await Promise.all(data.map((context) => dispatch(setContext.action, { data: context })));
	},
	[setContext.action]({ commit }, payload) {
		const { data } = payload;
		commit(SET_CONTEXT_DATA, { key: data.id, value: data });
	},
	async [getContextsOfService.action]({ dispatch, getters }, payload) {
		const { serviceId, forceGet } = payload;
		const dataIsMissing = getters[getServiceContexts.getter](serviceId).length === 0;
		const needToGet = dataIsMissing || forceGet;
		if (needToGet) {
			await (promises[serviceId] || (promises[serviceId] = dispatch(_fetchContextsOfService.action, { serviceId })));
		}
	},
	async [getContextsOfServiceBySlug.action]({ dispatch, getters, rootGetters }, { slug, forceGet }) {
		const dataIsMissing = getters[getServiceContextsBySlug.getter](slug).length === 0;
		const needToGet = dataIsMissing || forceGet;
		if (needToGet) {
			await dispatch(getServiceDataBySlug.fullPath, { slug }, { root: true });
			const service = rootGetters[getServiceBySlug.fullPath](slug);
			return dispatch(getContextsOfService.action, { serviceId: service.id });
		}
	},
	async [_fetchContextsOfService.action]({ dispatch }, payload) {
		const { serviceId } = payload;
		await dispatch(setContextFetchingLoading.action, true);
		const res = await api.getContextsOfService(serviceId);
		await dispatch(setContextFetchingLoading.action, false);
		await dispatch(setContexts.action, { data: res });
	},

	[setContextFetchingLoading.action]({ commit }, value) {
		commit(SET_CONTEXT_FETCHING_LOADING, value);
	},
};

export default actions;
